import React from "react";
import { Form, Input, FormInstance } from "antd";

export const CreateConsultantForm: React.FC<{ form: FormInstance }> = ({ form }) => {
  return (
    <Form form={form} layout="vertical">
      <Form.Item name="firstName" label="Vorname" rules={[{ required: true, message: "Bitte gib einen Vornamen ein" }]}>
        <Input />
      </Form.Item>
      <Form.Item
        name="lastName"
        label="Nachname"
        rules={[{ required: true, message: "Bitte gib einen Nachnamen ein" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        name="email"
        label="E-Mail-Adresse"
        rules={[
          { required: true, message: "Bitte gib eine E-Mail-Adresse ein" },
          { type: "email", message: "Bitte gib eine gültige E-Mail-Adresse ein" },
          {
            validator: (_, value) => {
              if (value && value !== value.toLowerCase()) {
                return Promise.reject("Die E-Mail-Adresse muss in Kleinbuchstaben sein");
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};
